<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>

				<em class="lt_text">S/O No</em>
				<span class="mgr_5"><SoSelect v-model.trim="so_dn" ph="Enter SO No" :backOrderMode="true" @set-invoice="setInvoice"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="ship_to_code" ph="Ship To" :showName="false" @set-partner="setPartner" /> </span>
				<span class="int_type_no_border mgr_5"> <PartnerSelect v-model="bill_to_code" ph="Bill To" :showName="false" @set-partner="setPartner" /> </span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_10"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<!-- <span class="int_type sm_int"> <input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" /> </span> -->
			</div>
			<div class="left_option">
				<span class="int_type_no_border">
					<ItemSelectMulti v-model.trim="items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>

				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<em class="lt_text">Item Color</em>
				<span class="int_type mgr_10">
					<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" />
				</span>

				<template v-if="true">
					<em class="lt_text">On Hand ></em>
					<currency-input type="text" style="width:60px;" v-model.trim="on_hand_q" :precision="0" :allow-negative="false" class="int_type al_right" @focus="$event.target.select()" />
					<em class="lt_text mgr_10">Received Date</em>
					<span class="mgr_5"> <CustomDatePicker v-model="received_date_from"/> ~ <CustomDatePicker v-model="received_date_to"/></span>
				</template>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
				<font color="red"><b>Takes long time without proper search condition(s) </b></font>
			</div>
		</div>

		<div class="fixed-table-container" style="padding-top:0px;">
			<div class="table-wrapper" style="height: 95%">
				<table class="list_tbl sticky_list_tbl">
					<thead>
						<tr>
							<th width="10px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th width="50px;">Sales Code</th>
							<th width="100px;">Sales Name</th>
							<th width="60px;">Ship To</th>
							<th width="180px;">Ship To Name</th>
							<th width="60px;" v-if="user.company_id == 'newjigu'">Bill To</th>
							<th width="100px;" v-if="user.company_id == 'newjigu'">Bill To Name</th>
							<th v-if="user.company_id != 'newjigu'">Ship To Address</th>
							<th width="90px;">{{ headers.class }} Code</th>
							<th width="200px;">{{ headers.class }} Name</th>
							<th width="80px;">Color</th>
							<th width="100px;">S/O No</th>
							<th width="80px;" v-if="user.company_id == 'newjigu'">S/O Date</th>
							<th width="100px;">Inv. No</th>
							<th width="80px;">Inv. Date</th>
							<th width="60px;">Price</th>
							<th width="50px;">Order Qty.</th>
							<th width="50px;">Bill Qty.</th>
							<th width="50px;">Back Qty.</th>
							<th width="50px;">On-Hand</th>
							<th width="50px;">Avail</th>
							<template v-if="user.company_id == 'newjigu'">
								<th width="50px;">Pend30</th>
								<th width="50px;">Pend90</th>
							</template>

							<th width="50px;">Onboard</th>
							<th width="80px;">Arr Date.</th>
							<!-- 
					<th width="5%">Inv. Date</th>
					
					<th width="5%">S/O Date</th>
					
					<th width="6%">Bill To Code</th>
					<th width="8%">Bill To Name</th>
					
					<th width="7%">Total Amt.</th>
					<th width="5%">Box</th>
					<th width="25%">Remark</th> -->
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in items" v-bind:key="item.invoice_item_no">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_left">{{ item.sales_group_code }}</td>
							<td class="al_left">{{ item.sales_group_name }}</td>
							<td class="al_left">
								<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_code }}</a>
							</td>
							<td class="al_left truncate" :title="item.ship_to_name">
								<a href="javascript:;" @click="gotoPartner(item.ship_to_code)">{{ item.ship_to_name }}</a>
							</td>
							<td class="al_left" v-if="user.company_id == 'newjigu'">
								<a href="javascript:;" @click="gotoPartner(item.bill_to_code)">{{ item.bill_to_code }}</a>
							</td>
							<td class="al_left truncate" v-if="user.company_id == 'newjigu'" :title="item.bill_to_name">
								<a href="javascript:;" @click="gotoPartner(item.bill_to_code)">{{ item.bill_to_name }}</a>
							</td>
							<td class="al_left truncate" v-if="user.company_id != 'newjigu'">{{ item.ship_to_address }}</td>
							<td class="al_left">{{ item.class_code }}</td>
							<td class="al_left truncate">{{ item.class_name }}</td>
							<td class="al_left" :style="item.active_yn == 'N' || item.so_blocked ? 'background-color: yellow;' : ''">
								<b v-if="item.active_yn == 'N'"><font color="red">!! </font></b><b v-if="item.so_blocked"><font color="red">B </font></b>{{ item.color_code }}
							</td>
							<td class="al_left">
								<a href="javascript:;" @click="selectSO(item)">{{ item.so_dn }}</a>
							</td>
							<td class="al_left" v-if="user.company_id == 'newjigu'">{{ item.so_date }}</td>
							<td class="al_left">
								<a href="javascript:;" @click="selectInvoice(item)">{{ item.invoice_dn }}</a>
							</td>
							<td class="al_left">{{ item.invoice_date }}</td>
							<td class="al_right">{{ item.unit_price | toCurrency }}</td>
							<td class="al_right">{{ item.quantity | commaSeparated }}</td>
							<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
							<td class="al_right">
								<font color="red">{{ item.bo_quantity | commaSeparated }}</font>
							</td>
							<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
							<td class="al_right">{{ item.available_quantity | commaSeparated }}</td>
							<template v-if="user.company_id == 'newjigu'">
								<td class="al_right">{{ item.pending_30_quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.pending_90_quantity | commaSeparated }}</td>
							</template>
							<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
							<td class="al_left">{{ item.arrival_date }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}, (Max {{ page_size }})</div>

		<Paging v-if="false" ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="view_bottom_bt">
			<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="makeSalesOrder()">Make Sales Order</a>
			<a href="javascript:void(0);" class="gray_bt" @click="exportExcel()">Excel</a>
			<a href="javascript:void(0);" class="gray_bt" @click="printConfirm()">Print</a>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiInvoiceIndex, apiSelectBackOrderItemList } from '@/api/sales/invoice.js';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
//import Modal from '@/components/common/Modal';
import { today, daysAgo } from '@/utils/date.js';
import { objectCopy, reportMrtUrl, reportRender, exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/',
			paging_yn: 'N',
			page_size: 500,
			page_no: 1,
			list_count: 0,

			invoice_date_from: daysAgo(7),
			invoice_date_to: today(),
			received_date_from: null,
			received_date_to: null,
			sales_group_code: null,
			ship_to_code: null,
			bill_to_code: null,
			//itemClasses: [],
			item_classes_string: '',
			item_classes: [],
			colors_string: '',
			colors: [],
			so_dn: null,
			keyword: null,
			on_hand_q: null,
			items_str: '',
			separator: ',',

			salesGroups: [],

			items: [],

			modalName: '',
			ship_or_bill: '',
			showModal: false,

			total_amount_sum: 0,

			allSelected: false,

			saveParam: {},
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		selected_items() {
			return this.items_str ? this.items_str.split(this.separator) : null;
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		SoSelect,
	},
	methods: {
		async exportExcel() {
			const { data } = await apiSelectBackOrderItemList(this.saveParam);

			const headers = [
				{ key: 'sales_group_code', name: 'Sales Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Name', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship To Code', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_name', name: 'Ship To Name', width: 15, dataType: defaultDataType.string },
				{ key: 'class_code', name: 'Class Code', width: 15, dataType: defaultDataType.string },
				{ key: 'class_name', name: 'Class Name', width: 15, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'so_dn', name: 'S/O No.', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Inv. No.', width: 15, dataType: defaultDataType.string },
				{ key: 'quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'available_quantity', name: 'Avail', width: 15, dataType: defaultDataType.currency },
				{ key: 'shipped_quantity', name: 'Bill Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'bo_quantity', name: 'Back Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'on_hand', name: 'On Hand', width: 15, dataType: defaultDataType.currency },
				{ key: 'on_board_quantity', name: 'On Board', width: 15, dataType: defaultDataType.currency },
				{ key: 'arrival_date', name: 'Arr. Date', width: 15, dataType: defaultDataType.string },
			];

			exportDataExcel(data.itemList, headers, 'Back Order Item List');
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},
		setPartner() {
			this.search();
		},
		makeSalesOrderConfirm(items) {
			var ship_to_count = 0;
			var selected_ship_to_code = null;
			var selected_invoice_item_nos = [];
			items.forEach(i => {
				selected_invoice_item_nos.push(i.invoice_item_no);
				if (ship_to_count == 0 || selected_ship_to_code != i.ship_to_code) {
					ship_to_count++;
					selected_ship_to_code = i.ship_to_code;
				}
			});

			if (ship_to_count > 1) {
				this.$toast.error('Multiple partners are selected');
				return;
			}

			//console.log(selected_ship_to_code, selected_invoice_item_nos);

			//this.$router.push({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, ship_to_code: selected_ship_to_code, invoice_item_nos: selected_invoice_item_nos.join() } });
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath, ship_to_code: selected_ship_to_code, invoice_item_nos: selected_invoice_item_nos.join() } });
			window.open(routeData.href, 'herp_so');
		},
		makeSalesOrder() {
			var selected_items = this.items.filter(i => i.selected);
			if (selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked).length == 0) {
				this.$toast.error('No valid items selected.');
				return;
			}

			if (selected_items.filter(i => i.active_yn == 'N' || i.so_blocked).length > 0) {
				//this.$toast.error('In-active or blocked item(s) included.');
				//this.$alertify.alert('Alert', 'In-active or blocked item(s) included.');

				var item_list_str = '';
				selected_items
					.filter(i => i.active_yn == 'N' || i.so_blocked)
					.forEach(i => {
						item_list_str += i.class_code + ' ' + i.color_code + '<br/>';
					});

				this.$alertify.confirm('In-Active or Blocked item(s) will be excluded. Proceed? <br/><br/>Invalid Item List<br/><br/>' + item_list_str, () => {
					this.makeSalesOrderConfirm(selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked));
				});

				//return;
			} else {
				this.makeSalesOrderConfirm(selected_items);
			}
			//console.log('test');
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		setInvoice(invoice) {
			this.so_dn = invoice.so_dn;
		},
		selectInvoice(item) {
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
		},
		selectSO(item) {
			this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: item.invoice_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectBackOrderItems(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		// setPartner(partner) {
		// 	//console.log(partner.code, partner.name);
		// 	if (this.ship_or_bill == 'ship') this.ship_to_code = partner.code;
		// 	else if (this.ship_or_bill == 'bill') this.bill_to_code = partner.code;
		// },
		selectPartner(ship_or_bill) {
			this.ship_or_bill = ship_or_bill;
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.invoice_date_from = daysAgo(7);
			this.invoice_date_to = today();
			this.received_date_from = null;
			this.received_date_to = null;
			this.so_dn = null;
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.item_classes_string = '';
			this.item_classes = [];
			this.colors_string = '';
			this.colors = [];
			this.on_hand_q = null;
			this.items_str = '';

			//this.selectInvoices();
			// this.dept_code = null;
		},
		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(this.separator);
			else this.item_classes = [];

			if (this.colors_string) this.colors = this.colors_string.split(this.separator);
			else this.colors = [];

			this.selectBackOrderItems();
		},
		async selectBackOrderItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			//console.log('select invoices');
			//const { data } = await selectAllPensioner();
			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				so_dn: this.so_dn,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,

				color_codes: this.colors,
				item_classes: this.item_classes,
				selected_items: this.selected_items,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,

				on_hand_q: this.on_hand_q,
			};

			const { data } = await apiSelectBackOrderItemList(param);

			let saveParam = {
				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				so_dn: this.so_dn,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,

				color_codes: this.colors,
				item_classes: this.item_classes,
				selected_items: this.selected_items,

				received_date_from: this.received_date_from,
				received_date_to: this.received_date_to,

				on_hand_q: this.on_hand_q,
			};

			this.saveParam = objectCopy(saveParam);

			//console.log(data);
			this.items = data.itemList;
			//this.list_count = data.list_count; //data.list_count;
			this.list_count = this.items.length;

			//this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			// var uri = '/sales/invoice_main?page_no=' + this.page_no;
			// if (this.keyword) uri += '&keyword=' + this.keyword;
			// if (this.invoice_date_from) uri += '&invoice_date_from=' + this.invoice_date_from;
			// if (this.invoice_date_to) uri += '&invoice_date_to=' + this.invoice_date_to;
			// if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			// if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			// if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			// this.$router.replace(uri).catch(err => err);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, code: code } });
		},
		async index() {
			const { data } = await apiInvoiceIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			await this.index();

			// this.so_date_from = today();
			// this.so_date_to = today();

			// if (this.$route.query.sort_key) this.sort_key = this.$route.query.sort_key;
			// if (this.$route.query.sort_direction) this.sort_direction = this.$route.query.sort_direction;
			// if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;

			// if (this.$route.query.partner_type) this.partner_type = this.$route.query.partner_type;
			// if (this.$route.query.grade) this.grade = this.$route.query.grade;
			// if (this.$route.query.state) this.state = this.$route.query.state;
			// if (this.$route.query.country) this.country = this.$route.query.country;
			if (this.$route.query.invoice_type) this.invoice_type = this.$route.query.invoice_type;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.invoice_date_from) this.invoice_date_from = this.$route.query.invoice_date_from;
			if (this.$route.query.invoice_date_to) this.invoice_date_to = this.$route.query.invoice_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;

			if (this.$route.query.received_date_from) this.received_date_from = this.$route.query.received_date_from;
			if (this.$route.query.received_date_to) this.received_date_to = this.$route.query.received_date_to;

			if (this.$route.query.items_str) {
				const separator = this.$route.query.separator || this.separator;
				const items = this.$route.query.items_str.split(separator);
				this.items_str = items.join(this.separator);
			}

			//this.$toast.info('Click "Search" button after setting search condition(s)');
			await this.selectBackOrderItems(this.$route.query.page_no);
		},
		async printConfirm() {
			if (this.list_count > 5000) {
				this.$alertify.confirm('If there are more than 5000 items, it may take a long time. Do you want to proceed?', async () => {
					await this.reportPrint();
				});
			} else {
				await this.reportPrint();
			}
		},
		async reportPrint() {
			const { data } = await apiSelectBackOrderItemList(this.saveParam);
			data.from_date = this.saveParam.invoice_date_from;
			data.to_date = this.saveParam.invoice_date_to;
			await reportRender(data, 'BackOrder', reportMrtUrl('BackOrder'));
		},
	},
	created() {
		this.$store.commit('setSideIndex', 3);
		this.$store.commit('setSelectedMenu', 'nav_li_back_order');
		this.$store.commit('setSubTitle', 'Sales -> Back Order');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
